import { ConstraintFacilityChokeBase } from './base/constraint-facility-choke-base';

export class ConstraintFacilityChoke extends ConstraintFacilityChokeBase { }